// CopyableCodeBlock.jsx
import React, { useState } from "react";
import { Button } from "react-bootstrap";

const CopyableCodeBlock = ({ children }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(children);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch (e) {
      console.error("Copy failed", e);
    }
  };

  return (
    <div
      className="copyable-card"
      style={{
        position: "relative",
        borderRadius: "6px",
        paddingTop: "40px", // space for fixed header button
        overflow: "hidden",
        marginTop:"-30px"
      }}
    >
      {/* Fixed header area with copy button */}
      <div
        style={{
          position: "absolute",
          top: 0,
          right: 0, 
          left: 0,
          padding: "8px 8px",
          display: "flex",
          justifyContent: "flex-end",
          zIndex: 2,
        }}
      >
        <Button
          variant="outline-secondary"
          size="sm"
          onClick={handleCopy}
        >
          {copied ? "Copied" : "Copy"}
        </Button>
      </div>

      {/* Scrollable content */}
      <pre
        style={{
          margin: 0,
          maxHeight: "260px", // card content height
          overflowY: "auto",
          padding: "12px",
          fontSize: "13px",
          lineHeight: 1.4,
          borderRadius: "0 0 6px 6px",
        }}
      >
        <code>{children}</code>
      </pre>
    </div>
  );
};

export default CopyableCodeBlock;
